import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, CheckboxModule, InputTextareaModule } from 'primeng';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IPageResult } from '../../interfaces/page-result';
import { IValetType } from '../../interfaces/valet-type';
import { IValetTypeFilter } from '../../interfaces/valet-type-filter';
import { ValetTypeService } from '../../services';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'valet-types',
  templateUrl: './manage-valet-type.component.html',
})
export class ValetTypesComponent implements OnInit {
  public page: IPageResult<IValetType> = {
    items: [],
    total: 0,
  };

  public event: any;
  public filter: Subject<IValetTypeFilter>;
  public filterVal: IValetTypeFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public valet: IValetType;
  public newvalet: boolean = false;
  public filterString: string;
  public newValetTypeForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public description: UntypedFormControl;
  public isActive: UntypedFormControl;
  public selectedEntry: any;

  constructor(private valetTypeService: ValetTypeService) {}

  ngOnInit() {
    this.initDefaultFilter();
    this.filter = new Subject<IValetTypeFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);

    // set formGroup instance
    this.name = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.description = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.isActive = new UntypedFormControl(true, Validators.required);

    this.newValetTypeForm = new UntypedFormGroup({
      name: this.name,
      description: this.description,
      isActive: this.isActive,
    });
  }

  load(filter: IValetTypeFilter) {
    this.valetTypeService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  showDialogToAdd() {
    this.newvalet = true;
    this.valet = {
      name: '',
      description: '',
      id: 0,
      isActive: true,
    };
    this.resetFormValues(this.valet);
    this.displayDialog = true;
  }

  save(formValues) {
    this.valet.name = formValues.name.trim();
    this.valet.description = formValues.description;
    this.valet.isActive = formValues.isActive;
    if (this.valet.name !== '') {
      this.valetTypeService.create(this.valet).then((res) => this.load(this.filterVal));
    }
    this.displayDialog = false;
  }

  close() {
    this.displayDialog = false;
  }

  resetFormValues(formValues) {
    this.newValetTypeForm.setValue({
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
    });
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.newvalet = false;
    this.valet = this.cloneValet(item);
    this.resetFormValues(this.valet);
    this.displayDialog = true;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event);
    }
  }

  cloneValet(c: IValetType): IValetType {
    let valet = { id: 0, name: '', description: '', isActive: true };
    for (let prop in c) {
      valet[prop] = c[prop];
    }

    return valet;
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    //var eventString = JSON.stringify(event);
    //if (eventString === this.filterString) return;
    //console.log(event);
    //this.filter.next(flatten(event));

    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name', // ASC
      sortOrder: 1,
      filters: {
        name: {},
        description: {},
        isActive: {},
      },
    };
  }

  clearFilter(table: any) {
    table.sortField = '';
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    console.log(this.filterVal);
    this.filter.next(this.filterVal);
  }
}
